import { ThemeProps, DefaultTheme, css } from 'styled-components';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import kebabCase from 'lodash/kebabCase';
import forEach from 'lodash/forEach';
import { TTypography } from './types';
import { defaultTheme } from './default-theme';

// eslint-disable-next-line max-len
export const getPaths = (
    themeConfig: DefaultTheme,
    formatKey: (key: string, value: string) => string
) =>
    reduce(
        Object.keys(themeConfig),
        (acc: string[], parameterKey) => {
            const parameter = themeConfig[parameterKey as keyof typeof themeConfig];
            forEach(Object.keys(parameter), (optionKey) => {
                let key = `${parameterKey}.${optionKey}`;
                if (parameterKey === 'colors') {
                    key = optionKey;
                }
                if (parameterKey !== 'typography') {
                    acc.push(formatKey(key, parameter[optionKey as keyof typeof parameter]));
                    return;
                }
                // fontSize's
                const typography = parameter[optionKey as keyof typeof parameter];
                forEach(Object.keys(typography), (innerParameterKey: string) => {
                    const fontSizeKey = `${parameterKey}.${optionKey}.${innerParameterKey}`;
                    acc.push(
                        formatKey(fontSizeKey, typography[innerParameterKey as keyof TTypography])
                    );
                });
            });
            return acc;
        },
        []
    );

export const addRootConfig = () => (props: ThemeProps<DefaultTheme>) => {
    const themeConfig: DefaultTheme = get(props, 'theme', defaultTheme);
    return getPaths(
        themeConfig,
        (key: string, value: string) => `--${kebabCase(key)}:${value}`
    ).join(';');
};

export const getFromTheme =
    (parameter: string) =>
    (props: ThemeProps<DefaultTheme>): string =>
        get(props, `theme.${parameter}`, '');

export const getBreakPoint = (breakpoint: keyof DefaultTheme['breakpoint']) =>
    getFromTheme(`breakpoint.${breakpoint}`);

export const getFontStyle = (fontSize: keyof DefaultTheme['typography']) => css`
    font-size: ${getFromTheme(`typography.${fontSize}.fontSize`)};
    font-weight: ${getFromTheme(`typography.${fontSize}.fontWeight`)};
`;
